export default __webpack_public_path__ + "static/media/047-cycling.43aa722b.svg";